// // src/contexts/FahrzeugContext.js
import React, { createContext, useContext, useEffect, useState } from 'react';
import axios from 'axios';
import { fetchWithRetry } from '../utils/fetchWithRetry';

const FahrzeugContext = createContext();
export const useFahrzeuge = () => useContext(FahrzeugContext);

export const FahrzeugProvider = ({ children }) => {
  const [bilder, setBilder] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const API_URL =
    process.env.REACT_APP_API_BASE_URL + '/items/Fahrzeuge?fields=id,img.*&filter[status][_eq]=published';

  useEffect(() => {
    const ac = new AbortController();
    const load = async () => {
      if (bilder.length > 0) { setLoading(false); return; }
      setLoading(true); setError(null);
      try {
        const res = await fetchWithRetry(
          () => axios.get(API_URL, { signal: ac.signal }),
          { retries: 3, baseDelay: 300, signal: ac.signal }
        );
        setBilder(res?.data?.data ?? []);
      } catch (e) {
        if (!ac.signal.aborted) setError('Fehler beim Laden der Bilder');
      } finally {
        if (!ac.signal.aborted) setLoading(false);
      }
    };
    load();
    /* return () => ac.abort(); */
  }, []); // eslint-disable-line

  return (
    <FahrzeugContext.Provider value={{ bilder, loading, error }}>
      {children}
    </FahrzeugContext.Provider>
  );
};

